import axios from 'axios'
import { Message } from 'element-ui'
// 引入 i18n 实例用于翻译网络请求错误消息
import i18n from '@/locale'

// 创建axios对象
let service = axios.create({
  baseURL: process.env.NODE_ENV == 'production' ? window.g.BASE_URL : process.env.VUE_APP_API_URL,
  timeout: 12000 // 请求的超时
})

// 添加请求拦截器,
service.interceptors.request.use(
  request => {
    let token = window.localStorage.getItem('token');
    // 设置请求的头信息
    request.headers['Authorization'] = `${token}`;
    request.headers['Content-Type'] = 'application/json';
    if (request.method === 'get') {
      request.params = request.data
    }
    return request
  },
  error => {
    Promise.reject(error)
  }
)

// 添加响应拦截器
service.interceptors.response.use(
  response => {
    // 600：登录过期,请重新登录  601: 您的帐号在其他地方已登录,被强制踢出 602: Token验证失败
    if (response.data.code === 600 || response.data.code === 601 || response.data.code === 602) {
      window.localStorage.removeItem("token");
      Message({
        message: response.data.msg || i18n.t('request.error'),
        type: 'error',
        duration: 1500,
        onClose: () => {
          return window.location.href = '/index'
        }
      })
    } else {
      return response.data || response.parmas
    }
  },
  error => {
    Promise.reject(error)
  }
)
export default service
